import { render } from "./AssessmentCharacteristics.vue?vue&type=template&id=1f1d095c&scoped=true"
import script from "./AssessmentCharacteristics.vue?vue&type=script&lang=js"
export * from "./AssessmentCharacteristics.vue?vue&type=script&lang=js"

import "./AssessmentCharacteristics.vue?vue&type=style&index=0&id=1f1d095c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f1d095c"

export default script